import { Flex, Typography, Grid } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { PageHeaderProps } from "types";

const PageHeader = ({
  title,
  subtitle,
  titleStyles,
  subtitleStyles,
  containerStyle,
  dotStyles,
  dot = true,
  headerRef,
  customElement,
}: PageHeaderProps) => {
  const { theme, isMobile } = useAntTheme();
  const breakpoint = Grid.useBreakpoint();

  let titleFontSize: number = 64;
  if (isMobile) titleFontSize = 40;

  return (
    <Flex
      vertical
      style={{
        padding: "24px 48px",
        ...containerStyle,
      }}
      gap={10}
      ref={headerRef}
    >
      <Typography.Title
        level={1}
        style={{
          fontSize: titleFontSize,
          color: theme.colorPrimary,
          fontWeight: 400,
          margin: 0,
          textAlign: "center",
          letterSpacing: "-2.2px",
          ...titleStyles,
        }}
      >
        {title}
        {(dot || customElement) && (
          <span
            style={{
              color: theme.colorTextDescription,
              ...dotStyles,
            }}
          >
            {customElement || "."}
          </span>
        )}
      </Typography.Title>
      {subtitle && (
        <Typography.Text
          style={{
            fontSize: breakpoint.xxl ? 24 : 19,
            fontWeight: 400,
            whiteSpace: "normal",
            lineHeight: 1.3,
            textAlign: "center",
            ...subtitleStyles,
          }}
        >
          {subtitle}
        </Typography.Text>
      )}
    </Flex>
  );
};

export default PageHeader;
